const regex = new RegExp("(:\\/|^[^\\/].*[.])", "i");

const isExternalLink = (url) => {
  return regex.test(url);
};

export default isExternalLink;
